import React from 'react';

import { Link } from 'react-router-dom';

const LandingFooter: React.FC = () => {
  return (
    <footer className="border-border border-t px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl text-center">
        <div className="flex items-center justify-center gap-4 text-sm">
          <Link to="/privacy" className="text-muted-foreground hover:text-foreground underline">
            Privacy Policy
          </Link>
          <span className="text-muted-foreground">|</span>
          <Link to="/terms" className="text-muted-foreground hover:text-foreground underline">
            Terms of Service
          </Link>
        </div>
        <p className="text-muted-foreground mt-4 text-sm">
          &copy; {new Date().getFullYear()} Conway. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default LandingFooter;
